import { RestClient } from "./base/rest.client";
import { CommonDto } from "../common.dto";
import { BASE_URL } from "../config";
import {
  PromoCodeListResponseSchema,
  PromoCodeResponseSchema,
  ActivatePromoRequestSchema,
  DeactivatePromoResponseSchema,
} from "./promo.schemas";

export interface PromoCode {
  code: string;
  discount_type: string;
  discount_value: number;
  description: string;
  service_type?: string | null;
  starts_at?: string | null;
  expires_at?: string | null;
}

class PromoClientClass extends RestClient {
  baseUrl = BASE_URL;

  /**
   * Получить список доступных промокодов
   */
  async getPromoList(): Promise<PromoCode[]> {
    const result = await this.request("GET", "/api/front/promo/list", {});

    const validated = this.validateResponse(
      result,
      CommonDto.withStatus(PromoCodeListResponseSchema)
    );

    return validated.data;
  }

  /**
   * Получить активный промокод пользователя
   */
  async getActivePromo(): Promise<PromoCode | null> {
    const result = await this.request("GET", "/api/front/promo/active", {});

    const validated = this.validateResponse(
      result,
      CommonDto.withStatus(PromoCodeResponseSchema.nullable())
    );

    return validated.data || null;
  }

  /**
   * Активировать промокод
   */
  async activatePromo(code: string): Promise<PromoCode> {
    const result = await this.request(
      "POST",
      "/api/front/promo/activate",
      {
        jsonPayload: { code },
      }
    );

    const validated = this.validateResponse(
      result,
      CommonDto.withStatus(PromoCodeResponseSchema)
    );

    return validated.data;
  }

  /**
   * Деактивировать активный промокод
   */
  async deactivatePromo(): Promise<void> {
    const result = await this.request("POST", "/api/front/promo/deactivate", {});

    this.validateResponse(result, CommonDto.withStatus(DeactivatePromoResponseSchema));
  }
}

export class PromoClient extends PromoClientClass {}

